import { Button } from "@mui/material";
import React from "react";

const AutobiaButton = ({
  children,
  content,
  color = "primary",
  variant = "contained",
  onClick,
  disabled = false,
  fullWidth = false,
  size = "medium",
  type = "button",
  sx = {},
  backgroundColor,
  height,
  borderRadius,
  paddingX,
  component,
  startIcon,
  endIcon,
  disableRipple = false,
  disabledBackgroundColor,
  disabledColor,
}) => {
  const baseStyles = {
    textTransform: "none",
    gap: "0.5rem",
    backgroundColor: backgroundColor || "auto",
    height: height || "auto",
    borderRadius: borderRadius || "auto",
    paddingX: paddingX || "auto",
  };

  const containedStyles = {
    ...baseStyles,
    color: "white",
    ...sx,
  };

  const outlinedStyles = {
    ...baseStyles,
    ...sx,
    "&:disabled": {
      backgroundColor: disabledBackgroundColor || "grey",
      color: disabledColor || "lightgrey",
    },
  };

  const buttonStyles = variant === "contained" || variant === undefined
    ? containedStyles
    : outlinedStyles;

  return (
    <Button
      color={color}
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      fullWidth={fullWidth}
      size={size}
      type={type}
      sx={buttonStyles}
      component={component || "button"}
      startIcon={startIcon}
      endIcon={endIcon}
      disableRipple={disableRipple}
    >
      {content || children}
    </Button>
  );
};

export default AutobiaButton;